import { render, staticRenderFns } from "./Form01_159.vue?vue&type=template&id=bf584e3a&scoped=true&"
import script from "./Form01_159.vue?vue&type=script&lang=js&"
export * from "./Form01_159.vue?vue&type=script&lang=js&"
import style0 from "./Form01_159.vue?vue&type=style&index=0&id=bf584e3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf584e3a",
  null
  
)

export default component.exports